import onSpotlightFilterLoaded from '../actions/onSpotlightFilterLoaded';
import getSpotlightRows from '../selectors/getSpotlightRows';
import { appendRowResponse } from 'owa-mail-list-response-processor';
import { TableView } from 'owa-mail-list-store';
import { OnInitialTableLoadComplete } from 'owa-mail-loading-action-types';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default async function loadSpotlightRowsFromSever(
    tableView: TableView,
    onInitialTableLoadComplete: OnInitialTableLoadComplete
) {
    const rows = await getSpotlightRows(
        tableView,
        tableView.tableQuery.listViewType === ReactListViewType.Conversation
    );

    appendRowResponse(tableView, rows, rows.length);

    onInitialTableLoadComplete(tableView, true, '200', false /* isTablePrefetched */);

    onSpotlightFilterLoaded();
}
